export default "__VITE_ASSET__B2$ojS0C__"